var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',[_c('v-card-title',[_c('h3',[_vm._v("Feedback")])]),_c('v-card-text',[_c('p',[_vm._v(" Use the button below to launch the feedback form. ")]),(_vm.windowUrl)?_c('v-btn',{attrs:{"color":"primary","dark":""},on:{"click":_vm.launchFeedbackPage}},[_vm._v("Provide Feedback")]):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }